import React from 'react'
import SigninCard from '../../components/cards/signin-card.jsx'
import css from './signin.scss'

class SigninPage extends React.Component {
    render() {
        return (
            <div className={css.container}>
                <SigninCard />
            </div>
        );
    }

}

export default SigninPage;